import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import styles from './SidebarLogo.module.css';

export const SidebarLogo = () => {
  const { isOpen } = useSidebarOpenState();

  return (
    <div
      className={styles.root}
      style={{
        width: isOpen
          ? sidebarConfig.drawerWidthOpen
          : sidebarConfig.drawerWidthClosed,
      }}
    >
      <Link
        to="/"
        underline="none"
        className={isOpen ? styles.linkOpen : styles.linkClosed}
        aria-label="ALLOS Developer Portal"
      >
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
